import React from 'react';
import { Eyebrow } from './Eyebrow';
import { Reveal } from './Reveal';
import { cn } from '../../src/lib/utils';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  align?: 'left' | 'center';
  size?: 'md' | 'lg';
  headingId?: string;
  className?: string;
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  size = 'md',
  headingId,
  className
}: SectionHeadingProps) {
  return <Reveal className={cn('flex flex-col gap-4', align === 'center' ? 'mx-auto items-center text-center' : 'items-start', className)} data-id="element-420" data-mp="i7yc6qjf9tf1">
      {eyebrow ? <Eyebrow data-id="element-421" data-mp="d6imgl6auyqb">{eyebrow}</Eyebrow> : null}
      <h2 id={headingId} className={cn('sf-display max-w-4xl text-balance leading-[1.04] text-text-primary', size === 'lg' ? 'text-[36px] sm:text-[52px] lg:text-[64px]' : 'text-[32px] sm:text-[42px] lg:text-[50px]')} data-id="element-422" data-mp="8atlcdemt9rw">
        {title}
      </h2>
      {description ? <p className="max-w-2xl text-[15px] leading-relaxed text-text-secondary sm:text-base" data-id="element-423" data-mp="1dygbbbg5ymox">
          {description}
        </p> : null}
    </Reveal>;
}